export const ar = {
  nav: {
    aboutUs: 'من نحن',
    services: 'خدماتنا',
    specialties: 'التخصصات',
    doctors: 'أطباؤنا',
    faq: 'الأسئلة الشائعة',
    contact: 'تواصل معنا',
  },
  auth: {
    doctorLogin: 'دخول الطبيب',
    patientLogin: 'دخول المستخدم',
  },
  hero: {
    title: 'استشر التخصصي',
    subtitle: 'وجهتك الذكية لاستشارات الحالات الصحية الدقيقة',
    description:
      'منصّة صحية رقمية آمنة تربط استشاريي مستشفى الملك فيصل التخصصي بالمرضى والأطباء الذين يحتاجون إلى استشارات فيديو متخصّصة أو آراء طبية ثانية للحالات الطبية المعقّدة.',
    ctaButton: 'سجّل الآن',
  },
  about: {
    title: 'من نحن؟',
    description:
      'منصّة صحية رقمية آمنة، تابعة لشركة التخصصي العامة المحدودة، إحدى شركات مستشفى الملك فيصل التخصصي القابضة، تربط استشاريي مستشفى الملك فيصل التخصصي بالمرضى والأطباء الذين يحتاجون إلى استشارات فيديو متخصّصة أو آراء طبية ثانية للحالات الطبية المعقّدة، بهدف دعم القرار الطبي برأي استشاري دقيق.',
    vision: {
      title: 'رؤيتنا',
      description:
        'نطمح إلى تمكين المرضى ومقدّمي الرعاية الصحية من الوصول إلى رأي طبي يواكب معايير المؤسسات الطبية المرجعية، وأن يكون «استشر التخصصي» مرجعًا موثوقًا لتقييم الحالات المعقّدة، والأمراض النادرة، وتقديم آراء طبية ثانية عالية الدقة.',
      iconAlt: 'رؤيتنا',
    },
    mission: {
      title: 'مهمتنا',
      description:
        'تقديم آراء واستشارات طبية داعمة عبر منظومة رقمية متقدمة تربط المستخدمين باستشاريين متخصصين، بهدف توضيح التشخيصات غير المؤكدة وتعزيز القرار الطبي بالاستناد إلى الأدلة والخبرة المؤسسية، دون أن تُغني عن الفحص السريري المباشر عند الحاجة.',
      iconAlt: 'مهمتنا',
    },
  },
  services: {
    title: 'خدماتنا',
    disclaimer:
      'جميع الخدمات المقدّمة عبر المنصة ذات طابع استشاري داعم، ولا تُغني عن الفحص السريري المباشر.',
    videoConsultation: {
      title: 'الاستشارات الطبية عبر الفيديو',
      description:
        'استشارات طبية متخصّصة عبر مكالمات فيديو آمنة ومشفّرة، يقدّمها استشاريون معتمدون في تخصصات دقيقة.',
      features: [
        'مناقشة الحالة الطبية بشكل مباشر مع استشاريين معتمدين.',
        'توضيح التشخيصات المحتملة وشرح الخيارات العلاجية المتاحة.',
        'الإجابة على استفسارات المريض أو الطبيب المعالج لدعم القرار الطبي.',
      ],
    },
    secondOpinion: {
      title: 'الرأي الطبي الثاني',
      description:
        'تمكّن المرضى والأطباء من الحصول على تقييم طبي إضافي للحالات المعقّدة من قبل استشاري مختص.',
      features: [
        'تقييم طبي إضافي للحالات المعقّدة أو غير الواضحة.',
        'مراجعة التقارير الطبية ونتائج الفحوصات وصور الأشعة.',
        'رأي تحليلي داعم يركّز على تفسير الحالة وتوضيح البدائل الممكنة.',
      ],
    },
  },
  specialties: {
    title: 'التخصصات الطبية',
    disclaimer:
      'جميع التوصيات المقدمة ذات طابع استشاري داعم، وتهدف إلى دعم القرار الطبي.',
    items: [
      {
        title: 'الأورام',
        description:
          'يقدّم استشاريو الأورام تقييمًا دقيقًا للحالات السرطانية بمختلف أنواعها، مع مراجعة متعمقة للتقارير والخطط العلاجية المقترحة بالاستناد إلى أحدث الأدلة العلمية.',
      },
      {
        title: 'أمراض القلب والأوعية الدموية',
        description:
          'تقييم متخصص للحالات القلبية الحرجة والمزمنة، بما يشمل قصور القلب، واضطرابات النظم، وأمراض الشرايين، مع مراجعة دقيقة للفحوصات والتقارير القلبية.',
      },
      {
        title: 'المخ والأعصاب',
        description:
          'تقييم شامل لاضطرابات الجهاز العصبي المعقّدة، مثل السكتات الدماغية، والصرع، والتصلب اللويحي، والاعتلالات العصبية، واضطرابات الحركة.',
      },
      {
        title: 'زراعة الأعضاء ورعاية ما بعد الزراعة',
        description:
          'تقييم الحالات المرشحة لزراعة الأعضاء، ومتابعة حالات ما بعد الزراعة، وقراءة التحاليل والمطابقة المناعية بدقة عالية.',
      },
      {
        title: 'الأمراض النادرة',
        description:
          'تقييمات دقيقة للحالات النادرة التي يصعب تشخيصها، مع الاعتماد على أحدث المراجع الطبية العالمية، وتقديم توجيهات تساعد على فهم الحالة.',
      },
      {
        title: 'الأمراض الوراثية',
        description:
          'تفسير الفحوصات الجينية المتقدمة وتوضيح الارتباطات الوراثية ذات الصلة بالأمراض المزمنة والنادرة، مع توصيات للفحوصات الإضافية والمتابعة.',
      },
    ],
  },
  whyUs: {
    title: 'لماذا استشر التخصصي؟',
    subtitle:
      'اختيارك لمنصة استشر التخصصي يعني الوصول إلى خبرات مستشفى الملك فيصل التخصصي أينما كنت.',
    features: [
      {
        title: 'استشارات فيديو آمنة',
        description:
          'استشارات في تخصصات طبية دقيقة عبر مكالمات مشفّرة مع استشاريين معتمدين.',
      },
      {
        title: 'آراء طبية ثانية موثوقة',
        description:
          'يقدّمها استشاريو مستشفى الملك فيصل التخصصي ذوو الخبرة العميقة.',
      },
      {
        title: 'خبرة في الحالات المعقّدة',
        description:
          'تقييمات دقيقة للحالات النادرة والمعقّدة بالاستناد إلى أحدث المراجع الطبية.',
      },
      {
        title: 'وصول بلا حدود',
        description: 'الخدمة متاحة داخل المملكة العربية السعودية ودوليًا.',
      },
      {
        title: 'حماية بياناتك',
        description: 'التزام بمعايير الحماية المحلية والدولية للبيانات الصحية.',
      },
    ],
  },
  howItWorks: {
    title: 'كيف تعمل منصة استشر التخصصي؟',
    videoConsultation: {
      title: 'أولًا: طلب استشارة طبية (استشارة فيديو)',
      steps: [
        'إنشاء حساب على المنصة',
        'اختيار خدمة استشارة فيديو',
        'رفع التقارير الطبية إن وُجدت',
        'اختيار التخصص أو الاستشاري وتحديد الموعد',
        'إتمام الدفع لتأكيد الحجز',
        'إجراء الاستشارة عبر اتصال مرئي آمن ومشفّر',
        'توثيق مخرجات الاستشارة ضمن السجلات الطبية الإلكترونية',
      ],
    },
    secondOpinion: {
      title: 'ثانيًا: طلب رأي طبي ثانٍ',
      steps: [
        'اختيار خدمة الرأي الطبي الثاني',
        'رفع التقارير الطبية وصور الأشعة',
        'مراجعة الحالة من قبل الاستشاري المختص',
        'استلام التقرير أو التقييم الطبي عبر المنصة',
      ],
    },
    warning: 'تنبيه: لا تُستخدم المنصة في الحالات الطبية الطارئة.',
  },
  cta: {
    title: 'جودة عالمية بعرض محلي',
    description:
      'احصل على استشارة طبية من أطباء مستشفى الملك فيصل التخصصي عبر منصة استشر التخصصي!',
    button: 'سجّل الآن',
  },
  targetAudience: {
    title: 'لمن تناسب الخدمة؟',
    items: [
      'للمرضى وأسرهم داخل السعودية أو خارجها ممّن يبحثون عن مرجعية موثوقة.',
      'لمن يرغب في رأي ثانٍ يطمئنه قبل قرار علاجي مهم.',
      'لمن يريد نقاشًا مباشرًا مع طبيب مختص حول أعراض أو خطة علاج.',
    ],
  },
  qualityPrivacy: {
    title: 'الجودة والخصوصية',
    features: [
      'التزام بمعايير الحماية المحلية والدولية للبيانات الصحية.',
      'تخزين آمن للوثائق الطبية، ووصول محدود لمن يحتاجها من الفريق الطبي.',
      'مطابقة دقيقة للتخصص قبل الاستشارة أو الرأي الطبي الثاني.',
    ],
    imageAlt: 'جودة الخدمة',
  },
  faq: {
    title: 'الأسئلة الشائعة',
    items: [
      {
        question: 'ما هي منصة استشر التخصصي؟',
        answer:
          'منصة رقمية آمنة تتيح الحصول على استشارات فيديو متخصصة وآراء طبية ثانية من استشاريي مستشفى الملك فيصل التخصصي.',
      },
      {
        question: 'ما نوع الخدمات التي تقدمها المنصة؟',
        answer:
          'استشارات فيديو طبية متخصصة، مراجعة التقارير الطبية، وآراء طبية ثانية للحالات المعقّدة.',
      },
      {
        question: 'كيف أبدأ في طلب الاستشارة الطبية؟',
        answer:
          'إنشاء حساب ← اختيار استشارة فيديو ← رفع التقارير ← تحديد الموعد ← الدفع.',
      },
      {
        question: 'هل يمكنني الحصول على رأي طبي ثانٍ؟',
        answer:
          'نعم، عبر رفع الملفات الطبية ليتم تقييمها من قبل أحد الاستشاريين المختصين.',
      },
      {
        question: 'ما الحالات المناسبة لاستخدام المنصة؟ وهل تشمل الطوارئ؟',
        answer:
          'المنصة مخصّصة للحالات المزمنة أو المعقّدة، ولا تُستخدم للحالات الطبية الطارئة.',
      },
      {
        question: 'هل تحافظ المنصة على سرية معلوماتي الطبية؟',
        answer:
          'نعم، يتم التعامل مع جميع المعلومات الطبية بسرية تامة، ويقتصر الوصول عليها على الاستشاري المختص فقط.',
      },
      {
        question: 'هل الأطباء على المنصة معتمدون؟',
        answer:
          'نعم، جميع الأطباء على المنصة استشاريون مرخّصون ومعتمدون ويعملون ضمن منظومة مستشفى الملك فيصل التخصصي.',
      },
      {
        question: 'كم تستغرق مدة الخدمة؟',
        answer:
          'الرأي الطبي الثاني: غالبًا من 48 إلى 72 ساعة عمل. الاستشارة عبر الفيديو: حسب الموعد المتاح.',
      },
      {
        question: 'هل يمكن إضافة أفراد الأسرة إلى حسابي؟',
        answer: 'نعم، يمكن إضافة أفراد الأسرة مع وجود ملف طبي مستقل لكل فرد.',
      },
      {
        question: 'هل تدعم المنصة الاستشارات في جميع التخصصات الطبية؟',
        answer:
          'تركّز المنصة على تخصصات طبية محددة ودقيقة، ويتم تحديثها باستمرار حسب توفر الخبرات الطبية.',
      },
      {
        question: 'هل الخدمة متاحة داخل المملكة فقط أم دوليًا؟',
        answer:
          'الخدمة متاحة داخل المملكة العربية السعودية ودوليًا، متى ما توفّر اتصال إنترنت مناسب.',
      },
      {
        question: 'ما هي طرق الدفع المتاحة؟',
        answer:
          'بطاقات الائتمان (فيزا / ماستركارد)، Apple Pay، stc pay، Samsung Pay.',
      },
      {
        question: 'هل تغطي شركات التأمين خدمة الاستشارات عبر المنصة؟',
        answer:
          'لا، لا تخضع الخدمة حاليًا للتغطية التأمينية ويتم الدفع مباشرة من المستخدم.',
      },
      {
        question: 'هل يمكن تعديل أو إلغاء الموعد؟',
        answer:
          'نعم، يمكن تعديل أو إلغاء الموعد وفق سياسة التعديل والإلغاء المعتمدة في المنصة.',
      },
      {
        question: 'ما هي الأجهزة والتقنيات المطلوبة لاستخدام المنصة؟',
        answer:
          'جهاز ذكي أو كمبيوتر، اتصال إنترنت مستقر، كاميرا وميكروفون لاستخدام الاستشارات عبر الفيديو.',
      },
    ],
  },
  footer: {
    tagline: 'رعاية صحية متكاملة\nفي راحة منزلك',
    quickLinks: 'روابط سريعة',
    contactUs: 'تواصل معنا',
    copyright:
      '© {year} Al Takassusi General Limited Company — part of King Faisal Specialist Hospital International Holding Company. All rights reserved.',
    termsAndPrivacy: 'سياسة الاستخدام والخصوصية',
  },
  doctors: {
    title: 'أطباؤنا',
    backToHome: 'العودة للرئيسية',
    distinguishingTitle: 'ما الذي يميز أطبّاؤنا؟',
    distinguishingFeatures: [
      'استشاريون يحملون خبرات طويلة في الحالات الدقيقة والنادرة.',
      'يعملون بمنهجية مبنية على الدليل الطبي وتحديث مستمر للمعرفة.',
      'يجيدون تبسيط المعلومة للمريض وأسرته.',
    ],
    pagination: {
      previous: 'الصفحة السابقة',
      next: 'الصفحة التالية',
      page: 'الصفحة {page}',
    },
  },
  common: {
    checkIconAlt: 'Check Icon',
    emailIconAlt: 'Email',
    phoneIconAlt: 'Phone',
    starIconAlt: 'star',
    arrowAlt: 'Arrow',
    chatOnWhatsapp: 'تواصل معنا عبر واتساب',
  },
} as const;

type DeepStringValues<T> = T extends string
  ? string
  : T extends readonly (infer U)[]
    ? ReadonlyArray<DeepStringValues<U>>
    : T extends object
      ? { [K in keyof T]: DeepStringValues<T[K]> }
      : T;

export type TranslationKeys = DeepStringValues<typeof ar>;
